import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpcatalog2deleteDeleteCatalogDraftsCurrentResponseSchema = jsonObject
export type tcpcatalog2deleteDeleteCatalogDraftsCurrentResponse = z.infer<typeof tcpcatalog2deleteDeleteCatalogDraftsCurrentResponseSchema>
